import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api, saveToken } from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      saveToken(data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#F5F4EF] flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#1E1E1E]/60 hover:text-[#1E1E1E]"><ArrowLeft size={14} /> Back to site</Link>
        <div className="mt-8 bg-white border border-[#1E1E1E]/10 p-10">
          <div className="flex items-center gap-3">
            <Logo size={56} />
            <div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-[#A67C00] font-semibold">PLST</div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-[#8A8A8A] mt-0.5">Admin panel</div>
            </div>
          </div>
          <h1 className="mt-8 font-display text-4xl tracking-tight font-bold">Sign in.</h1>

          <form onSubmit={submit} className="mt-8 space-y-6">
            <label className="block">
              <span className="text-[10px] uppercase tracking-[0.24em] text-[#8A8A8A]">Email</span>
              <input type="email" required data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} className="input" />
            </label>
            <label className="block">
              <span className="text-[10px] uppercase tracking-[0.24em] text-[#8A8A8A]">Password</span>
              <input type="password" required data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} className="input" />
            </label>
            <button type="submit" disabled={busy} data-testid="admin-login-submit"
              className="w-full bg-[#1E1E1E] text-[#F5F4EF] py-3.5 text-sm hover:bg-[#A67C00] transition-colors disabled:opacity-60">
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </motion.div>
      <style>{`
        .input { width:100%; background:transparent; border:0; border-bottom:1px solid rgba(46,46,46,0.2); padding:12px 0; font-size:15px; color:#1E1E1E; transition:border-color .3s; margin-top:6px; }
        .input:focus { outline:none; border-color:#A67C00; }
      `}</style>
    </div>
  );
}
